export const apiKeysQueryKeys = {
  get: () => ['apikeys'] as const,
  getAllForCompany: () => ['apikeys/all-for-company'] as const
}
